const stickyInfo = () => {
	const starterEl = document.querySelector(".stickyInfoStarterJs"); // permit to know when to sticku the element
	const stickyEl = document.querySelector(".stickyInfoJS"); // element who can be sticky

	if (!starterEl || !stickyEl) return;

	const ApplyHeightStickyinfo = () => {
		const stickyHeight = stickyEl.offsetHeight - 1;
		document.documentElement.style.setProperty(
			"--sticky-info-height",
			`${stickyHeight}px`
		);
	};

	const starterPositionBottom = starterEl.offsetTop + starterEl.offsetHeight;

	const toggleStickyClass = () => {
		if (window.scrollY >= starterPositionBottom) {
			stickyEl.classList.add("sticky");
			ApplyHeightStickyinfo();
		} else {
			stickyEl.classList.remove("sticky");
			document.documentElement.style.setProperty(
				"--sticky-info-height",
				`0px`
			);
		}
	};

	// update on scroll 'sticky'
	window.addEventListener("scroll", toggleStickyClass);
	window.addEventListener("resize", toggleStickyClass);

	// inital call
	toggleStickyClass();
};

export default stickyInfo;
